import { Product } from 'BrokerTsLib/src/enums'
import React, { useEffect, useState } from 'react'

import { IAvailableApps } from '../utils/availableApps'

export const baseUrl = process.env.PUBLIC_URL

export type EnvironmentType = 'production' | 'test' | 'development'
interface IAppContext {
  app: IAvailableApps['appId'] | null
  environment: EnvironmentType
  product: Product | null
}

interface IAppProvider {
  app: IAvailableApps['appId'] | null
  children?: React.ReactNode
}

export const AppContext = React.createContext<IAppContext>({
  app: null,
  environment: process.env.REACT_APP_ENVIRONMENT as EnvironmentType,
  product: null,
})

export const AppProvider = ({ app, children }: IAppProvider) => {
  const [prod, setProd] = useState<Product | null>(getProduct(app))

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']")! as HTMLLinkElement

    setProd(getProduct(app))
    switch (app) {
      case 'cestovko':
        document.title = 'CEStovka'
        link.href = baseUrl + '/favicon-cestovka.svg'
        break

      case 'chaloupka':
        document.title = 'CHALoupka'
        link.href = baseUrl + '/favicon-chaloupka.svg'
        break

      case 'carkulka-extra':
      case 'carkulka':
        document.title = 'CARkulka'
        link.href = baseUrl + '/favicon-carkulka.svg'
        break

      default:
        document.title = 'OKAppky'
        link.href = baseUrl + '/favicon-okappky.svg'
        break
    }
  }, [app])

  return (
    <AppContext.Provider
      value={{
        app,
        environment: process.env.REACT_APP_ENVIRONMENT as EnvironmentType,
        product: prod!,
      }}
    >
      {children && children}
    </AppContext.Provider>
  )
}

const getProduct = (app: IAvailableApps['appId'] | null) => {
  switch (app) {
    case 'cestovko':
      return Product.TravelInsurance

    case 'chaloupka':
      return Product.PropertyInsurance

    case 'carkulka-extra':
    case 'carkulka':
      return Product.VehicleInsurance

    default:
      return null
  }
}
